import { ScoreDelayComponent } from './../../_shared/components/score-delay/score-delay.component';
import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ScoreListPageModule } from '../../score-list/score-list.module';
import { StartMatchModule } from '../start-match/start-match.module';
import { TrackerBoardComponent } from './tracker-board.component';
import { ShotsModule } from '../../_shared/components/shots/shots.module';
import { EmptyPageModule } from '../../empty-page/empty-page.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ScoreListPageModule,
        TranslateModule.forChild(),
        StartMatchModule,
        ShotsModule,
        EmptyPageModule,
        ScoreDelayComponent
    ],
    declarations: [
        TrackerBoardComponent
    ],
    exports: [
        TrackerBoardComponent,
    ],
    providers: []
})
export class TrackerBoardModule { }
